import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HotelService {

  topCityList = [
    { code: 'del', name: 'Delhi & NCR' },
    { code: 'BOM', name: 'Mumbai' },
    { code: 'BLR', name: 'Bangalore' },
    { code: 'HYD', name: 'Hyderabad' },
  ];

  constructor(private http: HttpService) { }

  fetchStoreCityList(): void {
    this.http.hotelget('location/city-list').pipe(
      tap((res: any) => {
        localStorage.setItem('cityApi', JSON.stringify(res.data));
      })
    ).subscribe();
  }
}
